/**
 * PlanGrid — 평면 구성 정보 그리드 (목업 `.plan-grid`).
 *
 * 순수 프레젠테이션. 2열 그리드 셀(surface 배경, label 회색 + value 굵게).
 */

import React from 'react';

export interface PlanGridCell {
  label: string;
  value: string;
}

export interface PlanGridProps {
  cells: PlanGridCell[];
  className?: string;
}

export function PlanGrid({ cells, className = '' }: PlanGridProps) {
  return (
    <div className={`grid grid-cols-2 gap-[8px] ${className}`}>
      {cells.map((cell, i) => (
        <div
          key={i}
          className="rounded-ca-lg border border-ca-line-soft bg-ca-surface px-[11px] py-[10px]"
        >
          <div className="text-[11px] text-muted">{cell.label}</div>
          <div className="mt-[2px] text-[15px] font-extrabold text-ink">{cell.value}</div>
        </div>
      ))}
    </div>
  );
}

export default PlanGrid;
